// extracted by mini-css-extract-plugin
export default {"pageMarker":"PageMarker_pageMarker__3HRX8"};